import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [userFullName, setUserFullName] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Optionally, add a function to check if the user is authenticated by checking for the presence of a token in cookies
  const checkAuth = () => {
    const token = document.cookie.split('; ').find(row => row.startsWith('token='));
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ userPermissions, setUserPermissions, userFullName, setUserFullName, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
